import React from 'react'
import ExplorerLink from '../Link/ExplorerLink'
import ExternalLink from '../Link/ExternalLink'
import { TokenKya } from './types'
import { isAddress } from 'thirdweb/utils'
import { isValidUrl } from 'src/common/utils/validations'
import clsx from 'clsx'
import { formatSnakeCase } from 'src/common/utils/formatters/string'

interface TokenInfoBodyProps {
  tokenKya: TokenKya
}

const TokenInfoBody: React.FC<TokenInfoBodyProps> = ({ tokenKya }) => {
  const labelClasses = 'text-label2 text-main-muted font-normal'
  const valueClasses = 'text-label2 pl-3 text-right max-w-60'
  const linkClasses = 'group hover:text-primary'
  const iconClasses = 'group-hover:fill-primary fill-main-accent'

  const renderPropertyValue = (value: string) => {
    if (isAddress(value)) {
      return (
        <ExplorerLink
          className={clsx(valueClasses, linkClasses)}
          iconClassName={clsx(iconClasses)}
          hash={value}
          type='address'
        />
      )
    }
    if (isValidUrl(value)) {
      return (
        <ExternalLink
          hideIcon
          className={clsx(valueClasses, linkClasses)}
          link={value}
        >
          {value}
        </ExternalLink>
      )
    }
    return <span className={clsx(valueClasses)}>{value}</span>
  }

  const { description, properties } = tokenKya

  return (
    <div className='mt-4 text-sm space-y-2'>
      <span className='text-label1 text-center block my-2 text-main-muted font-bold'>
        KYA (Know-Your-Asset)
      </span>

      <div className='flex flex-row justify-between'>
        <span className={labelClasses}>Description:</span>
        {renderPropertyValue(description)}
      </div>
      {properties.map(property => (
        <div
          className='flex flex-row justify-between'
          key={property.property_type}
        >
          <span className={labelClasses}>
            {formatSnakeCase(property.property_type)}:
          </span>
          {renderPropertyValue(property.value)}
        </div>
      ))}
    </div>
  )
}

export default TokenInfoBody
